import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=7f8c65af&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=7f8c65af&prod&lang=scss&scoped=true"
import style1 from "./Support.vue?vue&type=style&index=1&id=7f8c65af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c65af",
  null
  
)

export default component.exports